import * as React from "react"
import {useEffect} from "react"
import {array, object, string} from "yup";
import {useValidatorSeeker} from "@ui-seeker/app";
import {AutocompleteAsyncSeeker} from "@ui-seeker/core"

import {WEBBACK_V2_API} from "@constants"
import {country, disabledCommonFiltersSubmit, seller, retailer} from "@signals"


export default function DIPSeller({  ...props }) {

    return <AutocompleteAsyncSeeker
        multiple
        urlAjax={`${WEBBACK_V2_API}/master-data/seller/options`}
        filters={{ country: country.value, retailer: retailer.value }}
        label="Sellers"
        placeholder="Search Seller..."
        value={seller.value}
        onChange={e => seller.value = e.target.value}
        {...props}
    />
}